<template>
	<div>
		<div
			class="modal fade modal-fullscreen-mobile"
			ref="modal"
			tabindex="-1"
			role="dialog"
			aria-hidden="true"
		>
			<div class="modal-dialog vld-parent" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h1 class="modal-title">Edit Account</h1>
						<button
							type="button"
							class="modal-close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<i class="sk-icon-times"></i>
						</button>
					</div>
					<div class="modal-body">
						<loading :active="loading" />
						<div class="modal-inner-content">
							<div class="account-inputs">
								<div>
									<SkInput
										:ref="'nameInput'"
										:name="'Full Name'"
										:placeholder="'John Smith'"
										:required="true"
										v-model="name"
									/>
									<SkInput
										:ref="'emailInput'"
										:name="'Email'"
										:type="'email'"
										:placeholder="'jsmith@gmail.com'"
										:required="true"
										:validation="emailRegex"
										v-model="email"
									/>
									<SkInput
										:name="'Apartment Number'"
										:placeholder="'55F'"
										v-model="aptNumber"
									/>
								</div>
							</div>
							<button
								class="button button-primary"
								@click="clickUpdateAccount"
							>
								Update Account
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.modal-body {
	justify-content: flex-start;
}

.modal-inner-content {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.account-inputs {
	height: 276px;
	min-height: 190px;
	flex-shrink: 1;
	display: flex;
	align-items: center;
}

.account-inputs .sk-input-wrapper:not(:last-child) {
	margin-bottom: 20px;
}

.account-inputs >>> .sk-input-wrapper,
.modal-inner-content .button {
	max-width: 335px !important;
	width: 335px !important;
}

.modal-inner-content .button {
	flex-shrink: 0;
}
</style>

<script>
import SkInput from "@/components/common/SkInput.vue"
import Loading from "vue-loading-overlay"

export default {
	name: "EditUserAccountModal",
	components: {
		SkInput,
		Loading
	},
	data: function() {
		return {
            emailRegex: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
			name: "",
			email: "",
			aptNumber: "",
			loading: false
		}
	},
	computed: {},
	methods: {
		open() {
			this.loading = false
			this.name = this.$store.state.user.username
			this.email = this.$store.state.user.email
			this.aptNumber = this.$store.state.user.apartmentNumber
			$(this.$refs.modal).modal("show")
		},
		async clickUpdateAccount() {
			try {
				this.$store.dispatch("sendMixpanelEvent", {
					msg: "Update Account Clicked",
				})
				this.loading = true
				const validName = this.$refs.nameInput.validate()
				const validEmail = this.$refs.emailInput.validate()
				if (validName && validEmail) {
					const success = await this.$store.dispatch("updateUser", {
						username: this.name,
						email: this.email,
						apartmentNumber: this.aptNumber
					})
					if (success) {
						this.close()
					} else {
						throw "Failed to update user!"
					}
				} else {
					throw `Invalid User Details, email: ${this.email}, username: ${this.name}`
				}
			} catch (e) {
				this.loading = false
				throw e
			}
		},
		close() {
            $(this.$refs.modal).modal("hide")
            this.loading = false
		}
	}
}
</script>
